import { RouteCondition } from "@app/shared/enum/route";
import { SelectedTitle, SelectedTitles } from "./setting.state";

export class ClearSetting {
    static readonly type = '[Setting] Clear setting';
}

export class SetReturnPath {
    static readonly type = '[Setting] Primary Path setting';
    constructor(public pathParts: string[] = [], public navigateFinally: Function) { }
}

export class ClearReturnPath {
    static readonly type = '[Setting] Primary Path clearing';
}

export class SetTitleSetList {
    static readonly type = '[Setting] Set Title Set List';
    constructor(public aliasId: string) { }
}

export class SelectTitles {
    static readonly type = '[Setting] Select titles';
    constructor(public selectedTitles: SelectedTitles) { }
}

export class SetScheduleTitleList {
    static readonly type = '[Setting] Set Schedule Title List';
}

export class SelectTitle {
    static readonly type = '[Setting] Select title';
    constructor(public selectedTitle: SelectedTitle) { }
}

export class SetAliasId {
    static readonly type = '[Setting] Set AliasId';
    constructor(public aliasId: string) { }
}

export class InitAliasId {
    static readonly type = '[Setting] Init AliasId';
}

export class SetButtonTitleList {
    static readonly type = '[Setting] Set Button Title List';
    constructor(public isWebview?: boolean, public corpPrefix?: string) { }
}

export class SetWebView {
    static readonly type = '[Setting] Set Webview';
    constructor(public isWebview?: boolean) { }
}

export class SetMenuList {
    static readonly type = '[Setting] Set Menu List';
}

export class SetWebviewMenuList {
    static readonly type = '[Setting] Set Webview Menu List';
    constructor(public corpPrefix?: string) { }
}

export class SetCorpPrefix {
    static readonly type = '[Setting] Set CorpPrefix';
    constructor() { }
}

export class SetTitleTagList {
    static readonly type = '[Setting] Set Title Tag List';
    constructor(public aliasId: string) { }
}

export class SetRouteCondition {
    static readonly type = '[Setting] Set route condition';
    constructor(public condition?: RouteCondition) { }
}

export class CheckCareConne {
    static readonly type = '[Setting] Check CareConne';
}